module.exports = __webpack_public_path__ + "img/اضلاع-خشک.9cfd8210.png";